import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getOrderFormColumnCountDirection } from "../../../http/api/MasterAPI";

const OrderFormColumnCountDirectionSelect = ({ value, error, onChangeValue }) => {
  const [listOrderFormColumnCountDirectionSelect, setListOrderFormColumnCountDirectionSelect] = useState([]);
  
  async function getOrderFormColumnCountDirectionSelect() {
    try {
      const response = await getOrderFormColumnCountDirection();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          orderFormColumnCountDirectionCd: element.varCd,
          orderFormColumnCountDirectionName: element.varValue1,
        }))
        .filter(
          (x) => x.orderFormColumnCountDirectionName && x.orderFormColumnCountDirectionName.trim() !== ""
        );
      setListOrderFormColumnCountDirectionSelect(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getOrderFormColumnCountDirectionSelect();
  }, []);

  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
        //onFocus={ () => validate.handleTouch("orderFormColumnCountDirectionCd")}
      >
        {listOrderFormColumnCountDirectionSelect.map((item) => (
          <MenuItem
            key={"orderFormColumnCountDirection" + item.orderFormColumnCountDirectionCd}
            value={item.orderFormColumnCountDirectionCd}
          >
            {item.orderFormColumnCountDirectionName}
          </MenuItem>
        ))}
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{color:"#d32f2f",marginLeft: 0}}>{error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default OrderFormColumnCountDirectionSelect;
